export const PenaltyFoulDrawnPlayer = {
  name: "penalty-foul-drawn-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "fouldrawn.select-player",
  showOn: [{ state: "primary", value: "penalty-foul-drawn-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  children: [
    {
      name: "pre-action",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "newEvent", value: null, type: "main" },
            { action: "saveData", value: "sevenMetrePenalty", type: "eventType" },
            { action: "saveData", value: "awarded", type: "subType" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "eventType",
              value: "sevenMetrePenalty",
              options: ["currentPlay"],
              operator: "not"
            },
            {
              item: "findInStore",
              field: "subType",
              value: "awarded",
              options: ["currentPlay"],
              operator: "not"
            },
          ],
        },
      ],
    },
    {
      name: "foul-drawn-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [
            { action: "sendEvent", value: "new", type: "main" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "eventType",
              value: "sevenMetrePenalty",
              options: ["currentPlay"],
              operator: "not"
            },
            {
              item: "findInStore",
              field: "subType",
              value: "awarded",
              options: ["currentPlay"],
              operator: "not"
            },
          ]
        },
        {
          actions: [
            { action: "clearData", value: ["flagged"], type: "main" },
            { action: "sendEvent", value: "edit", type: "main" },
          ],
          conditions: [
            {
              item: "findInStore",
              field: "eventType",
              value: "sevenMetrePenalty",
              options: ["currentPlay"],
            },
            {
              item: "findInStore",
              field: "subType",
              value: "awarded",
              options: ["currentPlay"],
            },
          ]
        },
        {
          actions: [
            { action: "copyEvent", value: "penalty-foul-drawn", type: "to" },
            {
              action: "nextState",
              value: "penalty-foul-player",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "card-buttons",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "confirm-later",
          component: "TypeButton",
          layout: "match-button",
          mode: "enable",
          text: "confirmLater",
          showOn: [true],
          startEvent: false,
          startPlay: false,
          actionGroups: [
            {
              actions: [
                { action: "saveData", type: "flagged", value: true },
                { action: "sendEvent", value: "new", type: "main" },
              ],
              conditions: [
                {
                  item: "findInStore",
                  field: "eventType",
                  value: "sevenMetrePenalty",
                  options: ["currentPlay"],
                  operator: "not"
                },
                {
                  item: "findInStore",
                  field: "subType",
                  value: "awarded",
                  options: ["currentPlay"],
                  operator: "not"
                },
              ]
            },
            {
              actions: [
                { action: "saveData", type: "flagged", value: true },
                { action: "clearData", value: ["personId"], type: "main" },
                { action: "sendEvent", value: "edit", type: "main" },
              ],
              conditions: [
                {
                  item: "findInStore",
                  field: "eventType",
                  value: "sevenMetrePenalty",
                  options: ["currentPlay"],
                },
                {
                  item: "findInStore",
                  field: "subType",
                  value: "awarded",
                  options: ["currentPlay"],
                },
              ]
            },
            {
              actions: [
                {
                  action: "nextState",
                  value: "penalty-foul-player",
                  type: "primary",
                },
                { action: "processInserts", value: "all", type: "inserts" },
              ],
            },
          ],
        },
      ],
    },
  ],
};
